exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".r-slideout--form-field_label[data-v-e4d2b86e]{font-size:12px;font-family:Fira Sans,sans-serif;letter-spacing:1.5px;color:#223b55;font-weight:400;padding:0}input[type=text][data-v-e4d2b86e]{background:#edf0f2;border:1px solid #c1c5c7}input[type=text][data-v-e4d2b86e]:disabled{opacity:.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e4d2b86e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/person/residents/new-resident-details/reusable/NewInputComponent.vue
// module id = 9QIu
// module chunks = 0 1